<template>
  <b-modal
    id="bank-account"
    title="Conta bancária"
    header-bg-variant="dark"
    header-close-variant="light"
    title-class="text-light font-18"
    hide-footer
  >
    <form @submit.prevent="handleSubmit">
      <div class="row">
        <!-- Bank Code -->
        <div class="col-12 col-md-4">
          <div class="form-group">
            <label for="bank_code">Código do banco</label>
            <input
              id="bank_code"
              v-model="account.bank_code"
              type="text"
              class="form-control"
              placeholder="Somente o código"
              :class="{
                'is-invalid': submitted && $v.account.bank_code.$error,
              }"
            />
            <div v-if="submitted && !$v.account.bank_code.required"
              class="invalid-feedback"
            >
              Número do banco é obrigatório
            </div>
          </div>
        </div>
        <!-- Bank Agency -->
        <div class="col-12 col-md-4">
          <div class="form-group">
            <label for="agency">Agência</label>
            <input
              id="agency"
              v-model="account.agency_number"
              type="text"
              name="agency"
              class="form-control"
              :class="{
                'is-invalid': submitted && $v.account.agency_number.$error,
              }"
            />
            <div v-if="submitted && $v.account.agency_number.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.account.agency_number.required">
                Número da agência é obrigatória.
              </span>
            </div>
          </div>
        </div>
        <!-- Bank Agency DV -->
        <div class="col-12 col-md-4">
          <div class="form-group">
            <label for="agency_dv">Dígito verificador</label>
            <input
              id="agency_dv"
              v-model="account.agency_dv"
              type="text"
              name="agency_dv"
              class="form-control"
              placeholder="Caso precise"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <!-- Bank Account Number -->
        <div class="col-12 col-md-8">
          <div class="form-group">
            <label for="account_number">Número da conta</label>
            <input
              id="account_number"
              v-model="account.account_number"
              type="text"
              class="form-control"
              :class="{
                'is-invalid': submitted && $v.account.account_number.$error,
              }"
            />
            <div v-if="submitted && !$v.account.account_number.required"
              class="invalid-feedback"
            >
              Número da conta é obrigatória
            </div>
          </div>
        </div>
        <!-- Bank Account DV -->
        <div class="col-12 col-md-4">
          <div class="form-group">
            <label for="account_dv">Dígito verificador</label>
            <input
              id="account_dv"
              v-model="account.account_dv"
              type="text"
              class="form-control"
              placeholder="Caso precise"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <!-- Account Holder Name -->
        <div class="col-12 col-md-7">
          <div class="form-group">
            <label for="name">Titular da conta</label>
            <input
              id="name"
              v-model="account.name"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': submitted && $v.account.name.$error }"
            />
            <div v-if="submitted && !$v.account.name.required"
              class="invalid-feedback"
            >
              Titular da conta é obrigatório
            </div>
          </div>
        </div>
        <!-- CPF/CNPJ -->
        <div class="col-12 col-md-5">
          <div class="form-group">
            <label for="document_number">CPF/CNPJ</label>
            <input
              id="document_number"
              :value="account.document_number"
              @input="onDocumentInput"
              type="text"
              maxlength="18"
              class="form-control"
              :class="{
                'is-invalid': submitted && $v.account.document_number.$error,
              }"
            />
            <div v-if="submitted && !$v.account.document_number.required"
              class="invalid-feedback"
            >
              CPF/CNPJ é obrigatório
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <div class="text-right">
        <b-button class="mr-1" variant="danger" @click="hideModal">
          Cancelar
        </b-button>
        <b-button type="submit" variant="success">Reembolsar</b-button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { onDocumentInput as handleDocumentInput } from '@src/helpers/documentValidator'

export default {
  data() {
    return {
      account: {
        bank_code: null,
        agency_number: null,
        agency_dv: null,
        account_number: null,
        account_dv: null,
        name: null,
        document_number: null,
      },
      currentPage: 1,
      endIndex: 6,
      perPage: 6,
      startIndex: 1,
      submitted: false
    }
  },
  validations: {
    account: {
      bank_code: { required },
      agency_number: { required },
      account_number: { required },
      name: { required },
      document_number: { required }
    }
  },
  methods: {
    onDocumentInput(event) {
      handleDocumentInput(event, (value) => {
        this.account.document_number = value;
      });
    },
    /**
     * Fires when user submits the form. Validates with vuelidate, if true, sends an event to the parent component to make the request, effecting the refund
     * @params no params
     * @return no return
     * @author Sandro Souza
     */
    handleSubmit() {
      this.submitted = true
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$emit('submit', this.account)
        this.$bvModal.hide('bank-account')
      }
    },
    /**
     * Hide modal when user clicks on cancel
     * @params no params
     * @return no return
     * @author Sandro Souza
     */
    hideModal() {
      this.submitted = false
      this.account = {}
      this.$bvModal.hide('bank-account')
    }
  }
}
</script>